import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import Ad from '@ifeng-fe/ui_pc_ad';
import TitleLine from './titleLine';
import ArticleArea from './articleArea';
import Assess from '../../../article/layout/content/rightContent/assess';
import { getSeoAbDisplay } from '../../../../common/seoAbBucket';

class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: {
                type,
                docData,
                docData: {
                    title,
                    newsTime,
                    updateTime,
                    videosPluginData,
                    slidesPluginData,
                    surveyPluginData,
                    subscribe = {},
                    seoAbValue,
                    seoTitle,
                    seoDescription,
                    quanPlugin,
                    type: docType,
                },
                asideAd2,
                asideAd3,
                assess,
                commentAd,
                commentBottomAd,
                hasCopyRight = false,
            },
        } = this.props;
        const pluginData = {
            videosPluginData,
            slidesPluginData,
            surveyPluginData,
        };
        const { articleTitle, articleSummary } = getSeoAbDisplay({
            title,
            seoAbValue,
            seoTitle,
            seoDescription,
            quanPlugin,
            type: docType || type,
        });
        const captionData = {
            title: articleTitle,
            newsTime,
            updateTime,
            subscribe,
            hasCopyRight,
        };

        return (
            <div className={styles.container}>
                <div className={styles.left_articleArea}>
                    <TitleLine content={captionData} />
                    <ArticleArea
                        articleData={docData}
                        pluginData={pluginData}
                        commentAd={commentAd}
                        commentBottomAd={commentBottomAd}
                        type={type}
                        articleSummary={articleSummary}
                    />
                </div>
                <div className={styles.right_adArea}>
                    <Ad content={asideAd2} styleName={styles.asideAd} />
                    <div className={styles.space25} />
                    <Assess content={assess} />
                    <div className={styles.space40} />
                    <Ad content={asideAd3} styleName={styles.asideAd} />
                </div>
            </div>
        );
    }
}

export default errorBoundary(Content);
